import React from 'react';
import ProductsSlider from './componentes/ProductsSlider';
import './App.css';

class App extends React.Component {
  render() {
    return (
      <>
       <ProductsSlider />
      </>
    );
  }
}

export default App;
